<script setup lang="ts" generic="TValue">
import { radioGroupKey } from '~/composables/group';

const props = defineProps<{
  label?: string
  value?: TValue
}>();

const group = inject(radioGroupKey);
const modelValue = computed(() => group?.isSelected(props.value) ?? false);
function onUpdate() {
  group?.toggle(props.value);
}
</script>

<template>
  <label
    class="flex-1 text-center relative isolate rounded-xl px-l py-m mb-m cursor-pointer font-semibold lg:text-lg
      bg-black/60 backdrop-blur-sm text-white whitespace-nowrap
      has-[:checked]:bg-white has-[:checked]:backdrop-blur-none has-[:checked]:text-neutral-10
      before:content-[''] before:hidden
      focus-within:has-[:checked]:before:block
      before:absolute before:top-full before:left-1/2 before:w-0 before:h-0 before:border-x-[18px] before:border-t-[15px] before:border-l-transparent before:border-r-transparent before:border-t-primary-40 before:-translate-x-1/2
      after:content-[''] after:hidden
      has-[:checked]:after:block
      after:absolute after:top-full after:left-1/2 after:w-0 after:h-0 after:border-x-[14px] after:border-t-[11px] after:border-l-transparent after:border-r-transparent after:border-t-white after:-translate-x-1/2
      focus-within:outline focus-within:outline-2 focus-within:outline-primary-40
      group-[.is-prestige]:rounded-none group-[.is-prestige]:text-white group-[.is-prestige]:uppercase group-[.is-prestige]:py-m group-[.is-prestige]:px-xl group-[.is-prestige]:font-title group-[.is-prestige]:has-[:checked]:bg-prestige-secondary-40 group-[.is-prestige]:after:border-t-prestige-secondary-40"
  >
    <input
      type="radio"
      class="peer sr-only"
      :value
      :checked="modelValue"
      autocomplete="off"
      @change="onUpdate"
    >
    <span v-text="label" />
  </label>
</template>

<style lang="css" scoped>
label:focus-within:not(:has(:focus-visible)) {
  @apply outline-none;
}
label:focus-within:not(:has(:focus-visible))::before {
  @apply hidden;
}
</style>
